module.exports = __webpack_public_path__ + "img/61.653b4a30.png";